import { useEffect } from 'react'
import { useAuth } from '../../contexts/Auth'
import i18n from '../../i18n/setupLocalization'
import { User } from '../../components/user/User'
import PageTitle from '../../components/PageTitle'
import { useAppDispatch } from '../../store/hooks'
import { setSelectedUser } from '../../store/UserReducer'
import LocalizationKeys from '../../i18n/LocalizationKeys'
import { Button, Card, Col, Flex, Form, Input, Row } from 'antd'

export default function UserProfilePage() {
  const [form] = Form.useForm()
  const { currentUser } = useAuth()
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (currentUser == undefined) {
      return
    }
    form.setFieldValue('name', currentUser.name)
    form.setFieldValue('email', currentUser.email)
    dispatch(setSelectedUser(currentUser))
  }, [currentUser])
  return (
    <>
      {currentUser && (
        <Row gutter={[16, 16]}>
          <Col span={24} style={{ marginTop: 20 }}>
            <PageTitle
              type="sympa"
              title={i18n.t(LocalizationKeys.Page.UserProfilePage.Title)}
            />
          </Col>
          <Col span={24}>
            <Card>
              <Form form={form} layout="vertical">
                <Form.Item
                  label={i18n.t(LocalizationKeys.Misc.Form.Name)}
                  name="name"
                >
                  <Input disabled={true} />
                </Form.Item>
                <Form.Item
                  label={i18n.t(LocalizationKeys.Misc.Form.Email)}
                  name="email"
                >
                  <Input disabled={true} />
                </Form.Item>
                <Button disabled={true} type="primary">
                  {i18n.t(LocalizationKeys.Misc.Button.Save)}
                </Button>
              </Form>
            </Card>
          </Col>
          <Col span={24}>
            <Flex vertical gap={10}>
              <PageTitle
                level={5}
                title={i18n.t(
                  LocalizationKeys.Page.ProfileSettingsPage.DangerZone
                )}
              />
              <User.DeleteAlert user={currentUser} />
            </Flex>
          </Col>
        </Row>
      )}
    </>
  )
}
